import { createSelector } from '@reduxjs/toolkit';

import { State } from './reducer';

export const selectDevice = (state: { device: State }) => state.device;
export const selectIsDeviceOnline = createSelector(selectDevice, (device) => device.isOnline);
export const selectDisplayMessage = createSelector(selectDevice, (device) => device.displayMessage);
